import React, { useState, useEffect, useMemo, useRef } from 'react';
import './assests/css/style.css';
import imgurl from './assests/images/imgurl';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal'
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import AlertComp from './Alert';
import { useSelector, useDispatch } from 'react-redux'
import { setcountrycode, setmobnum, setidentasmale, setgender } from './Reducers/reducer'
import { Card, CardContent, Select, ToggleButton, ToggleButtonGroup } from '@mui/material';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import i18next from 'i18next';
import LanguageSelector from './LanguageSelector';
import codes from 'country-calling-code'
import ReactCountryFlag from 'react-country-flag';
import { setLanguage } from './Redux/languageSlice';
import MobileHeader from './components/MobileHeader';
import { serviceDown, trackEvent } from './utils/UtilityFunctions';
import { postApi } from './api/services';
import swal from 'sweetalert';
import MainLoader from './components/MainLoader';


function LoginPage() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [countryCode, setCountryCode] = useState('34');
    const [phoneno, setPhoneno] = useState('')
    const locale = useSelector((state) => state.language.langData);
    const [alertopen, setalertopen] = useState(false)
    const [alertmsg, setalertmsg] = useState('Test')
    const [modalopen, setModalOpen] = useState(false);
    const [genderchk, setgenderchk] = useState('Yes')
    const [lang, setLang] = useState('')
    const [errorMssg, setErrorMssg] = useState("");
    const [euCodes, setEuCodes] = useState([])
    const [isMobile, setIsMobile] = useState(false);
    const [toggleVal, setToggleVal] = useState('customer');
    const [doctLogin, setDoctLogin] = useState(false);
    const handleOpen = () => setModalOpen(true);
    const handleClose = () => setModalOpen(false);
    const [isLoading, setIsLoading] = useState(false)

    const countrycodeobj = {
      49: "DE",
      33: "FR",
      39: "IT",
      34: "ES",
      31: "NL",
      32: "BE",
      46: "SE",
      47: "NO",
      358: "FI",
      45: "DK",
      48: "PL",
      41: "CH",
      351: "PT",
      30: "GR",
      43: "AT",
      91: "IN",
    };

    const europeanCountryCodes = useMemo(() => [
      'AT', // Austria
      'BE', // Belgium
      'BG', // Bulgaria
      'HR', // Croatia
      'CY', // Cyprus
      'CZ', // Czech Republic
      'DK', // Denmark
      'EE', // Estonia
      'FI', // Finland
      'FR', // France
      'DE', // Germany
      'GR', // Greece
      'HU', // Hungary
      'IE', // Ireland
      'IT', // Italy
      'LV', // Latvia
      'LT', // Lithuania
      'LU', // Luxembourg
      'MT', // Malta
      'NL', // Netherlands
      'PL', // Poland
      'PT', // Portugal
      'RO', // Romania
      'SK', // Slovakia
      'SI', // Slovenia
      'ES', // Spain
      'SE',  // Sweden
      // "CH", // Switzerland
      // "IN"
    ], [])

    useEffect(() => {
      if(!localStorage.getItem("country-code")){
        localStorage.setItem('country-code', "Spain")
      }
      localStorage.setItem('isDoctor', true);
    }, [])

    useEffect(() => {
      if (!window.cordova) {
        let isMobile = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
        if (!isMobile) {
          setIsMobile(false);
          localStorage.setItem('user_role', 'doctor')
        } else {
          setIsMobile(true);
          localStorage.setItem('user_role', 'nurse')
        }
      }
    }, [isMobile]);

    useEffect(() => {
      const euCallingCodes = codes.filter((c) => europeanCountryCodes.includes(c.isoCode2))      
      setEuCodes(euCallingCodes)
    }, [europeanCountryCodes])

    useEffect(() => {
      const searchParams = new URLSearchParams(location.search);
      console.log(searchParams);
      const langParam = searchParams.get("lang");

      if (langParam && ["en", "es", "fr"].includes(langParam)) {
        setLang(langParam);
        dispatch(setLanguage(langParam));
        i18next.changeLanguage(langParam);
        location.href = location?.href.split("?")[0];
      }

      const hash = window.location.hash; // "#/loginpage?gender=m"
      const queryString = hash.split('?')[1]; // "gender=m"

      const params = queryString?.split('=')[1]
      const gender = params
      if(gender && gender === "m"){
        localStorage.setItem('temp_gender', "male")
      } else if(gender && gender === "f"){
        localStorage.setItem('temp_gender', "female")
      }
      if(queryString){
        location.href = location?.href.split("?")[0];
      }
    }, [location, lang]);

    const profile = useSelector((state) => state.user.profile);

    const handleCountryCodeChange = (event) => {
      let countryCode = codes.filter((c) => c.countryCodes[0] === event.target.value)      
      dispatch(setcountrycode(countryCode[0].isoCode2));
      localStorage.setItem('country-code', countryCode[0]?.country)
      setCountryCode(event.target.value);
      // localStorage.setItem('country-code', `+${event.target.value}`)
    };

    const checkRole = async () => {
      setIsLoading(true)
      let params = {
        phone_number: countryCode + phoneno,
      }
      console.log('check_user_role params', params);
      try {
        let res = await postApi('check_user_role', params)
        console.log('check_user_role res', res);
        setIsLoading(false)
        if(res?.role?.toUpperCase() === 'DOES_NOT_EXIST'){
          swal({
            title: i18next.t(res.status),
            text: i18next.t('Contact admin for more details')
          })
        } else {
          getotp()
          localStorage.setItem('user_role', res.role)
        }
      } catch (err) {
        console.log('err', err);
        serviceDown(navigate)
      }
    }

    const handleSubmit = () => {
      if(localStorage.getItem('user_role').toUpperCase() === 'DOCTOR'){
        checkDoctor()
      } else if(localStorage.getItem('user_role').toUpperCase() === 'NURSE'){
        getNurse()
      }
    }

    async function getotp() {
      // navigate('/otppage')

      if (phoneno != "") {
        let data = JSON.stringify({
          user_no: countryCode + phoneno,
        });

        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: "https://aloxa.ai/flaskservice/getotp",
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };
        try {
          const response = await axios.request(config);
          console.log("OTP API response", response.data);
          localStorage.setItem("phno", JSON.parse(data).user_no);
          dispatch(setmobnum("+" + countryCode + phoneno));
          navigate("/otppage", { state: { from: "loginpage" } });
          // Call your tracking event with required values
          await trackEvent("user_requested_code", "success", '', countryCode + phoneno);
        } catch (error) {
          console.error("OTP API error", error);
          setalertmsg("Error sending OTP. Please check mobile number.");
          setalertopen(true);
          setTimeout(() => setalertopen(false), 4000);
          // Call tracking with error
          await trackEvent("user_requested_code", "fail", error.message, countryCode + phoneno);
        }
      } else {
        setalertmsg(i18next.t("Enter your mobile number"));
        setalertopen(true);
        setTimeout(() => {
          setalertopen(false);
        }, 4000);
      }
    }

    const checkDoctor = async () => {
      let params = {
        phone_number: countryCode + phoneno
      }
      console.log("get_doctor_by_phone params", params);
      try {
        let res = await postApi('get_doctor_by_phone', params)
        console.log("get_doctor_by_phone res", res);
        setIsLoading(false)
        if(res?.doctor_exist){
          sessionStorage.setItem("checkUser", JSON.stringify(res));
          localStorage.setItem('doctorobj', JSON.stringify(res))
          localStorage.setItem('doctorLogged', true)
          getotp()
        } else {
          // navigate("/doctorregistration")
          swal({
            title: i18next.t('Clinic Not Registered'),
            text: i18next.t('Your clinic is not registered on this platform. To proceed, please contact your administrator for access.'),
            icon: 'warning'
          }).then(() => {
            // navigate('/loginpage')
          })
        }
      } catch (err) {
        console.log("err", err);
        // await trackEvent('check_user', 'fail', err, localStorage.getItem('phno'))
        setIsLoading(false)
        serviceDown() 
      }
    }

    const getNurse = async () => {
      let params = {
        phone_number: countryCode + phoneno
      }
      console.log("get_nurse_by_phone params", params);
      try {
        let res = await postApi('get_nurse_by_phone', params)
        console.log("get_nurse_by_phone res", res);
        setIsLoading(false)
        if(res?.error){
          serviceDown(navigate, '/loginpage')
        } else if (!res.nurse_id) {
          swal({
            title: i18next.t('Clinic Not Registered'),
            text: i18next.t('Your clinic is not registered on this platform. To proceed, please contact your administrator for access.'),
            icon: 'warning'
          }).then(() => {
            // navigate('/loginpage')
          })
        } else {
          sessionStorage.setItem("checkUser", JSON.stringify(res));
          localStorage.setItem('doctorobj', JSON.stringify(res))
          localStorage.setItem('doctorLogged', true)
          // navigate("/homepage")
          getotp()
        }
      } catch (err) {
        console.log("err", err);
        setIsLoading(false)
        serviceDown()
      }  
    }

    function checkGender(e) {
      console.log(e.target.value);
      setgenderchk(e.target.value);
      dispatch(setidentasmale(e.target.value));
      setTimeout(() => {
        e.target.value == "Yes" && setModalOpen(false);
      }, 1000);
    }

    const changeHandler = (value) => {
      setCountryCode(value);
    };

    const checkPhonenum = (event) => {
      const input = event.target.value;

      // Allow only digits
      if (!/^\d*$/.test(input)) {
        setErrorMssg("Only numeric characters are allowed.");
        return;
      }

      // Prevent input if it starts with 0
      if (input.length > 0 && input[0] === "0") {
        setErrorMssg(
          "Phone number should not begin with 0. Please enter a valid number."
        );
        return;
      }

      // Valid input
      setErrorMssg("");
      let addTenDigit = input.slice(0, 15);
      localStorage.setItem("phno", addTenDigit.slice(0, 15));
      setPhoneno(addTenDigit);
    };

    const handleToggleChange = (event) => {
      setToggleVal(event.target.value);
      if(event.target.value === "doctor"){
        setDoctLogin(true);
        localStorage.setItem('isDoctor', true);
      } else {
        setDoctLogin(false);
        localStorage.setItem('isDoctor', false);
      }
    };

    return (
      <>
        {isLoading && <MainLoader/>}
        <>
          {/* {!isMobile ? 
          (
            <div className='loginpage doctor desktop d-flex justify-content-center align-items-center flex-direction-column p-20px'>
              <Grid container spacing={0} className='d-flex justify-content-center align-items-center mb-20px'>
                <Grid item xs={12} className='d-flex justify-content-center align-items-center'>
                  <h2 className='loginpageheading'>{i18next.t("Experience on Mobile")}</h2>
                </Grid>
              </Grid>
              <Grid container spacing={0} className='d-flex justify-content-center align-items-center'>
                <Grid item xs={12} className='d-flex justify-content-center align-items-center'>
                  <p>
                    {i18next.t("We will use your mobile phone camera to analyse the hair. Please scan the QR code below to get started.")}
                  </p>
                </Grid>
              </Grid>    
              <Grid container spacing={0} className='d-flex justify-content-center align-items-center'>
                <Grid item xs={12} className='d-flex justify-content-center align-items-center'>
                  <img className='w-50' src={imgurl.clinicalopexiaqr}/>
                </Grid>
              </Grid>          
            </div> 
          ) : (
          )} */}
            <div className="loginpage doctor">
              <div className="">
                <div
                  className={
                    window.cordova ? "language-select-div" : "language-select-div web"
                  }
                >
                  <LanguageSelector from={"Loginpage"} />
                  {isMobile && <MobileHeader showDrawer={true}/>}
                </div>

                <Card className="otpcard loginpginput">
                  <CardContent className="pb-16px">
                    {
                      isMobile && 
                        <div className="loginpglogo mt-5px">
                          <img src={imgurl.hairlossaiLogo} alt="New Logo" className='mainlogo'/>
                        </div>
                    }
                    <div className="otppgtext">
                      <p>{i18next.t("Sign In with Mobile Number")}</p>
                    </div>

                    <Grid container spacing={0} className="otptextfield">
                      <Grid item xs={12}>
                        <Select
                          value={countryCode}
                          onChange={handleCountryCodeChange}
                          className="country-select countryDropdown"
                          disableUnderline={true}
                        >
                          {euCodes.map((o, i) => {
                            return (
                              <MenuItem value={o.countryCodes[0]} key={i}>
                                <ReactCountryFlag
                                  className="countryFlags countryimage"
                                  countryCode={o.isoCode2}
                                  svg
                                />
                                {o.country + " " + "(+" + o.countryCodes[0] + ")"}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </Grid>
                      <Grid item xs={12} className="mt-20px">
                        <TextField
                          value={phoneno}
                          id="outlined-basic"
                          type="text"
                          label=""
                          variant="outlined"
                          placeholder={i18next.t("Enter your mobile number")}
                          className="whitefield"
                          onChange={(e) => {
                            checkPhonenum(e);
                          }}
                        />
                      </Grid>
                    </Grid>
                    {errorMssg ? (
                      <div className="phoneNoErrorMessage">
                        {i18next.t(errorMssg)}
                      </div>
                    ) : (
                      ""
                    )}

                    <Button
                      variant="contained"
                      className="commonButton mt-30px"
                      onClick={() => handleSubmit()}
                    >
                      {i18next.t("Proceed")}
                    </Button>
                  </CardContent>
                </Card>
              </div>
            </div>
          <AlertComp open={alertopen} msg={alertmsg} type={"error"} />
          <Modal
                  open={modalopen}
                  // onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box className="previewmodal loginmodal">
                    <Grid xs={12} className="slide3gridtwo">
                      <Grid xs={4}>
                        <h2 className="question1 slide3">{"Are you a male?"}</h2>
                      </Grid>

                      <Grid xs={4}>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          // defaultValue='Yes'
                          onChange={(e) => checkGender(e)}
                          className="modalradiobtns"
                        >
                          <FormControlLabel
                            className="modalradiolabels"
                            control={
                              <Radio
                                icon={<CheckCircleOutlineIcon />}
                                checkedIcon={<CheckCircleIcon />}
                                sx={{
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 48,
                                  },
                                }}
                              />
                            }
                            value="Yes"
                            label="Yes"
                          />
                          <FormControlLabel
                            control={
                              <Radio
                                icon={<CheckCircleOutlineIcon />}
                                checkedIcon={<CheckCircleIcon />}
                                sx={{
                                  "& .MuiSvgIcon-root": {
                                    fontSize: 48,
                                  },
                                }}
                              />
                            }
                            value="No"
                            label="No"
                          />
                        </RadioGroup>
                        {genderchk == "No" && (
                          <h2 className="question1 slide3 sorrywrapper">
                            {"Sorry. This application is only for males."}
                          </h2>
                        )}
                      </Grid>
                    </Grid>
                  </Box>
          </Modal>
        </>
      </>
    );
}

export default LoginPage;
